import {useEffect, useRef} from 'react'

import {V2_FIELDS} from '../schema/contactSchema.js'

export const useAlertAfterLead = ({
  hasContacted,
  isLogged,
  domain,
  alertSearch,
  adId,
  form,
  logger,
  onAlertCreated
}) => {
  const hasCreatedAlertRef = useRef(false)

  useEffect(() => {
    if (!hasContacted || hasCreatedAlertRef.current || !isLogged) {
      return
    }

    if (!form.getFieldValue(V2_FIELDS.ENABLE_ALERTS)) {
      return
    }

    hasCreatedAlertRef.current = true

    domain
      .get('create_alert_user_alert_use_case')
      .execute({search: alertSearch, adId})
      .then(alert => onAlertCreated?.(alert?.alertId))
      .catch(error => {
        logger?.error({
          name: `[ContactSeller]: "adId: ${adId}" alert creation failed after the lead`,
          message: `[ContactSeller]: ${error?.message}`
        })
      })
  }, [hasContacted, isLogged, domain, alertSearch, adId, form, logger, onAlertCreated])
}

export default useAlertAfterLead
